"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayLoadSortOrder = void 0;
exports.PayLoadSortOrderFromJSON = PayLoadSortOrderFromJSON;
exports.PayLoadSortOrderFromJSONTyped = PayLoadSortOrderFromJSONTyped;
exports.PayLoadSortOrderToJSON = PayLoadSortOrderToJSON;
exports.PayLoadSortOrderToJSONTyped = PayLoadSortOrderToJSONTyped;
/**
 * SortOrder for PayLoad
 * @export
 * @enum {string}
 */
var PayLoadSortOrder;
(function (PayLoadSortOrder) {
    PayLoadSortOrder["Asc"] = "asc";
    PayLoadSortOrder["Desc"] = "desc";
})(PayLoadSortOrder || (exports.PayLoadSortOrder = PayLoadSortOrder = {}));
function PayLoadSortOrderFromJSON(json) {
    return PayLoadSortOrderFromJSONTyped(json, false);
}
function PayLoadSortOrderFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PayLoadSortOrderToJSON(value) {
    return PayLoadSortOrderToJSONTyped(value, false);
}
function PayLoadSortOrderToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
